export interface LoggedUser{
    usuario: string,
    roles: Array<string>,
    publico: Array<string>,
    token: string,
    expiration: string,
}

export function GetVoidLoggedUser(): LoggedUser{
    return{
        usuario: '',
        roles: [],
        publico: [],
        token: '',
        expiration: '',
    }
}

export function SetLoggedUser(data: any,token?: any): LoggedUser{
    return{
        usuario: data.username??'',
        roles: data.role??[],
        publico: data.publico??[],
        token: data.token??token,
        expiration: data.exp??'',
    }
}

export const mapTokenData = (tokenData: any, tokenP: string): { usuario: string, roles: string[],publico: string[], token: string, expiration: string } => {
    //console.log(tokenData["publico"]);
    return {
      usuario: tokenData["username"] || '',
      roles: tokenData["role"] || [],
      token: tokenP, // Si tienes el token, puedes incluirlo aquí
      expiration: tokenData["exp"] || '', // Convertir el timestamp de exp a una fecha legible
      publico: tokenData["publico"] || [],
    };
  };